import type {RevaSpec, RevaSpecOutputPage} from "@reva/shared/spec-conversion";

/**
 * Gruppen-Präfixe in reva_indication_groups, mit denen die ENERGY_VALUE-Zeilen je Darstellung dupliziert
 * werden (#19096): Vorschau im Objekt-Tab „Energieausweis" bzw. volle Ansicht im Wert-Tab „Energiewert".
 */
export const ENERGY_GROUP_PREFIXES = {
    preview: "object_energy_",
    value: "value_energy_",
} as const;

export type EnergyOutputVariant = keyof typeof ENERGY_GROUP_PREFIXES;

const ALL_PREFIXES = Object.values(ENERGY_GROUP_PREFIXES);

/**
 * Reduziert die ENERGY_VALUE-Page auf die Gruppen einer Darstellung: gibt es Gruppen mit ihrem Präfix, nur
 * diese; sonst die Gruppen ohne Präfix. Der Fallback hält REVA gegen eine AVM-DB lauffähig, die die
 * Präfix-Gruppen noch nicht kennt (LIVE, s. AVM-KOMPATIBILITAET.md).
 */
export function filterEnergyPageForVariant(page: RevaSpecOutputPage, variant: EnergyOutputVariant): RevaSpecOutputPage {
    const prefix = ENERGY_GROUP_PREFIXES[variant];
    const hasVariantGroups = page.rowGroups.some((group) => group.group.startsWith(prefix));
    const keep = (group: string) =>
        hasVariantGroups ? group.startsWith(prefix) : !ALL_PREFIXES.some((p) => group.startsWith(p));
    return {
        ...page,
        rowGroups: page.rowGroups.filter((group) => keep(group.group)),
        rows: page.rows.filter((row) => keep(row.group)),
    };
}

/** Spec mit auf die Darstellung reduzierter ENERGY_VALUE-Page, siehe {@link filterEnergyPageForVariant}. */
export function withEnergyPageForVariant(spec: RevaSpec, variant: EnergyOutputVariant): RevaSpec {
    return {
        ...spec,
        pages: {...spec.pages, ENERGY_VALUE: filterEnergyPageForVariant(spec.pages.ENERGY_VALUE, variant)},
    };
}
